import { render } from "./RzList.vue?vue&type=template&id=0f6fa534"
import script from "./RzList.vue?vue&type=script&lang=js"
export * from "./RzList.vue?vue&type=script&lang=js"

import exportComponent from "D:\\fxwl\\wx-wl_full\\wx-wl_full\\fxwl\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__